import { SERVICES } from "@/lib/clinic";
import { ArrowUpRight } from "lucide-react";

const toneClasses = {
  primary: "bg-[#3A564A] text-[#FAFAF9] border-[#3A564A]",
  accent: "bg-[#E08570] text-stone-900 border-[#E08570]",
  muted: "bg-white text-stone-900 border-stone-200",
};

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-20 sm:py-24 lg:py-32 bg-gradient-to-b from-[#FAFAF9] to-white"
    >
      <div className="container mx-auto px-6 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-12 lg:mb-16">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.22em] text-[#3A564A]">
              <span className="h-px w-8 bg-[#3A564A]" />
              What we do
            </span>
            <h2 className="font-display font-bold text-stone-900 text-4xl sm:text-5xl tracking-tight mt-5 leading-[1.05]">
              Every smile, every stage of life.
            </h2>
          </div>
          <p className="text-stone-600 max-w-md leading-relaxed">
            From a child's first check-up to braces, root canals and cosmetic
            polish — under one roof, by specialists who genuinely care.
          </p>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-5 lg:gap-6 auto-rows-fr">
          {SERVICES.map((s, i) => {
            const tone = toneClasses[s.tone] || toneClasses.muted;
            return (
              <article
                key={s.title}
                data-testid={`service-card-${i}`}
                className={`relative rounded-3xl border p-7 lg:p-8 group hover:-translate-y-1 transition-all duration-300 hover:shadow-lg overflow-hidden ${tone} ${s.span}`}
              >
                <div className="flex items-start justify-between gap-4">
                  <h3 className="font-display font-bold text-xl sm:text-2xl tracking-tight">
                    {s.title}
                  </h3>
                  <ArrowUpRight className="w-5 h-5 opacity-60 group-hover:opacity-100 group-hover:rotate-12 transition-all" />
                </div>
                <p
                  className={`mt-4 text-sm leading-relaxed ${
                    s.tone === "primary"
                      ? "text-[#FAFAF9]/85"
                      : s.tone === "accent"
                      ? "text-stone-900/80"
                      : "text-stone-600"
                  }`}
                >
                  {s.desc}
                </p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
